import {LinkProps} from '@chakra-ui/react';
import {StyledLink} from 'components/theme/StyledLink';
import {RouteNames} from 'modules/navigation';
import {useLocalizedNavigation} from 'modules/navigation/hooks';
import NextLink from 'next/link';
import React from 'react';

export interface GeoLinkProps extends LinkProps {
	/** Link label [NOT a translation key, but his result] */
	label?: string | JSX.Element;
	/** target windows name */
	target?: string;
	/** Link to an internal route */
	to: RouteNames;
	/** potential args of link */
	args?: any[];
	/** display variant format of the link */
	variant?: 'Button' | 'Link' | 'ButtonOutline';
}

/**
 * Customized link
 *
 * @param props
 * @returns a react component.
 */
export const GeoLink: React.FC<GeoLinkProps> = ({
	label,
	to,
	target,
	args = [],
	children,
	variant = 'Link',
	...props
}: GeoLinkProps) => {
	const {getPath} = useLocalizedNavigation();

	return (
		<NextLink passHref href={getPath(to, ...args)}>
			{['Button', 'ButtonOutline'].includes(variant) ? (
				<StyledLink
					as={props.as}
					target={target}
					maxWidth={props.maxWidth}
					maxHeight={props.maxHeight}
					width={props.width ?? undefined}
					justifyContent={props.justifyContent ?? 'center'}
					borderWidth={variant === 'ButtonOutline' ? '1px' : props.borderWidth}
					borderRadius={props.borderRadius ?? '3xl'}
					borderColor={props.borderColor ?? '#00BBFF'}
					border={props.border}
					py={props.py ?? 2}
					px={props.px ?? 7}
					ml={props.ml ?? undefined}
					variant={undefined}
					alignItems='center'
					color={
						variant === 'ButtonOutline' ? '#00BBFF' : props.color ?? 'white'
					}
					bg={variant === 'ButtonOutline' ? null : props.bg ?? '#00BBFF'}
					fontWeight={props.fontWeight ?? 600}
					fontSize={props.fontSize ?? 'xs'}
					size={props.size}
					_hover={props._hover}
					boxShadow={
						props.boxShadow ??
						// eslint-disable-next-line react/jsx-indent
						'0.5px 0.5px 0 rgba(0,0,0,0.4), -0.5px -0.5px 0 rgba(255,255,255,1)'
					}
					sx={props.sx}
					{...props}
				>
					{label ?? children}
				</StyledLink>
			) : (
				<StyledLink
					as={props.as}
					target={target}
					fontWeight={props.fontWeight ?? 600}
					fontSize={props.fontSize ?? 'xs'}
					maxWidth={props.maxWidth}
					maxHeight={props.maxHeight}
					{...props}
				>
					{label ?? children}
				</StyledLink>
			)}
		</NextLink>
	);
};
